module.exports = __webpack_public_path__ + "static/media/ka.8a5904fc.png";